module.exports = __webpack_public_path__ + "static/img/7.619a4a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/7.png
// module id = wyxN
// module chunks = 0